import { useSelector } from "react-redux";
import Icon from "../../stories/Foundation/Icons/";
import { IconColours } from "../../stories/Foundation/Icons/interface";
import LinkWrap from "../../stories/shared/LinkWrap/component";
import featureAttr from "../../utils/featureAttr";
import NewsLineup from "./components/newsLineup";
import { RootState } from "./interface";
import { PATHS_WITH_NEWS_BAR } from "./constants";
import classes from "./styles/themes/_default.module.scss";

const NewsBar = () => {
    const path = useSelector((state: RootState) => state.app.path);
    const singleLineup = useSelector((state: RootState) => state.singleLineup);
    if (!Object.keys(PATHS_WITH_NEWS_BAR).includes(path)) {
        return null;
    }

    if (!singleLineup?.content?.length) {
        return null;
    }

    return (
        <div className={classes.newsBarContainer} data-cy="newsbar">
            <div className={classes.newsBarInner}>
                <LinkWrap
                    url={PATHS_WITH_NEWS_BAR[path].url}
                    className={classes.newsBarHeader}
                    {...featureAttr({
                        name: "swimlane",
                        instance: "news-bar",
                        position: 0,
                    })}
                    data-testid="latestNews"
                >
                    <span>Latest News </span>
                    <Icon colour={IconColours.red500} name="Arrow" size="24" />
                </LinkWrap>
                <NewsLineup />
            </div>
        </div>
    );
};
export default NewsBar;
